<template src="./Home.html">

</template>

<script>
import Booking from './Booking'

export default {
  name: 'Home',
  components: {
    Booking
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/Home.vue